<template>
  <div class="container-fluid vld-parent">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: table_module}">{{module}}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <div class="avatar-md mr-3">
                <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-20">
                  <i class="bx bx-car"></i>
                </span>
              </div>
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-18 mt-1">{{data.crs_brand_name}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="font-size-15">Details :</h5>
            <p class="text-muted mb-0" v-html="data.crs_brand_description"></p>
          </div>
        </div>
        <div class="card min-h-350">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="card-title">Cars Model</h4>
              <template v-if="local_users.usr_admin != ''">
                <button
                  type="button"
                  class="btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle"
                  @click="qucikCreateShow(true)"
                >
                  <i class="bx bx-plus mr-2"></i> New
                </button>
              </template>
            </div>
            <tables
              module="Brand Mobil"
              table_module="cars_model"
              alias_table="crs_model"
              :data="data_model"
              :fields="fields_model"
              :local_users="local_users"
              @fetchData="fetchData"
              :hidden-checkbox="false"
              :sortable="{
                orderBy : orderBy,
                sort : sort,
              }"
            ></tables>
          </div>
        </div>
      </div>
    </div>

    <quickCreate
       v-if="childDataLoaded"
      :visible="visible"
      :fields="fields_model"
      module="Brand Mobil"
      table_module="cars_model"
      alias_table="crs_model"
      @hiddenSideSearch="visible = false"
      @fetch="fetchData"
      :defaultValue="{crs_brand_id : data.crs_brand_id}"
    ></quickCreate>
  </div>
</template>

<script>
import tables from "@/components/tables";
import quickCreate from "@/components/quick_create";

export default {
  data() {
    return {
      isLoading: false,
      module: "Brand Mobil",
      table_module: "cars_brand",
      alias_table: "crs_brand",
      data: {},
      uuid: this.$route.params.uuid,
      show: 10,
      page: 1,
      totalData: 0,
      massData: [],
      fields_model: {},
      data_model: {},
      visible: false,
      dataSearch: {},
      orderBy : 'created_at',
      sort : 'desc',
      childDataLoaded : false,
    };
  },
  components: {
    tables,
    quickCreate,
  },
  mounted() {
    this.fetchDetail();
  },
  computed: {
    local_users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.fetchData();
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    fetchData(arm) {
      this.fields_model = {}
      this.visible = false
      var params = {};
      if (arm == undefined) {
        params = {
          page: this.page,
          show: this.show,
          order_by: this.orderBy,
          type_sort: this.sort,
        };
      } else {
        params = {
          page: (arm.page == undefined) ? this.page : arm.page,
          show: (arm.show == undefined) ? this.show : arm.show,
          order_by: (arm.orderBy == undefined) ? this.orderBy : arm.orderBy,
          type_sort: (arm.sort == undefined) ? this.sort : arm.sort,
        };
      }

      this.orderBy = params.order_by;
      this.sort = params.type_sort;

      if (this.dataSearch.search != undefined) {
        for (const key in this.dataSearch.search) {
          params["search[" + key + "]"] = this.dataSearch.search[key];
        }
      }

      params["filter[crs_brand_id]"] = this.data.crs_brand_id;

      this.axios.get("/cars_model", { params: params }).then((response) => {
        this.fields_model = response.data.data.fields;
        this.data_model = response.data.data["cars_model"];
        this.childDataLoaded = true;
      });
    },
    qucikCreateShow(arm){
      this.visible = arm
    }
  },
};
</script>